export const rrjApiBase = "https://api.renrenjiang.cn";
